import * as React from "react";
import type { SVGProps } from "react";
const TriangleIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="m12 2.5 9.96 17.25H2.04zm0 3L4.64 18.25H19.36z" clipRule="evenodd" /></svg>;
export default TriangleIcon;